package navigation.settings

import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val settingsModule
    get() =
        module {
            factoryOf(::SettingsScreenModel)
        }
